import { render, staticRenderFns } from "./Dsp.vue?vue&type=template&id=312353e4"
import script from "./Dsp.vue?vue&type=script&lang=js"
export * from "./Dsp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports